import React, { Component } from 'react';
import { Button, TextField, Dialog, DialogActions, DialogContent, Fab, Tooltip, withStyles, IconButton} from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import AddIcon from '@material-ui/icons/Add';
import SendIcon from '@material-ui/icons/Send';
import firebase from '../../firebase'

const styles = theme => ({
    paper: {
        padding: 16,
        margin: theme.spacing(2),
        // height: '100%',
        overflowY: 'auto'
    },
    root: {
        width: '100%',
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
    },
    nested: {
        paddingLeft: theme.spacing(4),
    },
    absolute: {
        margin: 0,
        top: 'auto',
        right: 20,
        bottom: 20,
        left: 'auto',
        position: 'fixed',
    },
})

class CreateNotification extends Component {

    constructor(props) {
        super(props)

        this.state = {
            sendMode: false,
            title: "",
            body: "",
            image: "",
            open: false
        }

        this.database = firebase.database().ref().child('notifications')
    }

    componentDidMount() {
        const { sendMode, notification } = this.props
        if (sendMode === true) {
            const { title, body, image} = notification
            this.setState({
                sendMode: sendMode,
                title: title,
                body: body,
                image: image,
                save: false
            })
        }
    }

    handleClickOpen = () => {
        this.setState({
            open: true
        })
    }

    handleClose = () => {
        this.setState({
            open: false
        })
    }

    handleSubmit = () => {

        const { title, body, image, save } = this.state
        
        this.addNotificationObject(title, body, image)

        if (save) {
            this.saveNotificationObject(title, body, image)
        }

    }

    saveNotificationObject = (title, body, image) => {
        firebase.database().ref().child('notification-templates').push({
            title,
            body,
            image
        })

        this.setState({
            open: false,
        })
    }


    addNotificationObject = (title, body, image) => {
        this.database.push({
            title,
            body,
            image
        })

        this.setState({
            open: false,
        })
    }

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value
        })
    }

    handleSaveChange = (event) => {
        this.setState({ ...this.state, [event.target.name]: event.target.checked });
    };

    render() {
        const { open, save, title, body, image } = this.state
        const { sendMode, classes } = this.props
        return (
            <div>
                {
                    sendMode ?
                        <IconButton edge="end" onClick={this.handleClickOpen}>
                            <SendIcon />
                        </IconButton>
                        :
                        <Tooltip title="Add">
                            <Fab color="secondary" className={classes.absolute} onClick={this.handleClickOpen}>
                                <AddIcon />
                            </Fab>
                        </Tooltip>

                }
                <Dialog open={open} onClose={this.handleClose}>
                    {/* <DialogTitle id="form-dialog-title">{'Send Notification 🔔'}</DialogTitle> */}
                    <DialogContent>
                        <form>
                            <TextField
                                autoFocus
                                margin="normal"
                                id="title"
                                label="Notification Title"
                                type="text"
                                value={title}
                                onChange={this.handleChange('title')}
                                fullWidth
                                color="secondary"
                                autoComplete="off"
                                required
                                variant="outlined"
                            />
                            <TextField
                                margin="normal"
                                id="body"
                                label="Notification Body"
                                type="text"
                                value={body}
                                onChange={this.handleChange('body')}
                                fullWidth
                                color="secondary"
                                autoComplete="off"
                                variant="outlined"
                            />
                            <TextField
                                margin="normal"
                                id="image"
                                label="Notification Image"
                                type="text"
                                value={image}
                                onChange={this.handleChange('image')}
                                fullWidth
                                color="secondary"
                                autoComplete="off"
                                variant="outlined"
                            />
                            <FormControlLabel
                                control={<Switch checked={save} onChange={this.handleSaveChange} name="save" disabled={sendMode}/>}
                                label="Save as Template"
                            />
                        </form>
                    </DialogContent>
                    <DialogActions style={{ marginRight: 16, marginBottom: 8, }}>
                        <Button onClick={this.handleClose} color="primary">
                            Cancel
                        </Button>
                        <Button type="submit" variant="contained" onClick={this.handleSubmit} color="primary">
                            Send Notification
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }
}

export default withStyles(styles)(CreateNotification)